import {
  collection,
  getDocs,
  getDoc,
  doc,
  query,
  where,
  addDoc,
  updateDoc,
  deleteDoc,
  setDoc,
} from 'firebase/firestore'
import { db } from './firebaseConfig'
// User interface
export interface FirestoreUser {
  name: string
  email: string
  role?: string
  roles?: string[]
  activeRole?: 'buyer' | 'seller'
}
// Create a new user document
export const createUser = async (userData: FirestoreUser, userId: string) => {
  try {
    const userRef = doc(db, 'users', userId)
    await setDoc(userRef, {
      ...userData,
      createdAt: new Date(),
    })
    return userId
  } catch (error) {
    console.error('Error creating user:', error)
    throw error
  }
}
// Get user by ID
export const getUserById = async (userId: string) => {
  try {
    const userRef = doc(db, 'users', userId)
    const userSnapshot = await getDoc(userRef)
    if (userSnapshot.exists()) {
      return {
        id: userSnapshot.id,
        ...userSnapshot.data(),
      } as FirestoreUser
    }
    return null
  } catch (error) {
    console.error('Error fetching user:', error)
    throw error
  }
}
// Update user
export const updateUser = async (
  userId: string,
  updates: Partial<FirestoreUser>,
) => {
  try {
    const userRef = doc(db, 'users', userId)
    await updateDoc(userRef, updates)
    return true
  } catch (error) {
    console.error('Error updating user:', error)
    throw error
  }
}
// Delete user
export const deleteUser = async (userId: string) => {
  try {
    const userRef = doc(db, 'users', userId)
    await deleteDoc(userRef)
    return true
  } catch (error) {
    console.error('Error deleting user:', error)
    throw error
  }
}
// Get notifications by user
export const getNotificationsByUser = async (userId: string) => {
  try {
    const notificationsRef = collection(db, 'notifications')
    const q = query(notificationsRef, where('userId', '==', userId))
    const querySnapshot = await getDocs(q)
    const notifications: any[] = []
    querySnapshot.forEach((doc) => {
      notifications.push({ id: doc.id, ...doc.data() })
    })
    return notifications
  } catch (error) {
    console.error('Error fetching user notifications:', error)
    throw error
  }
}
// Mark notification as read
export const markNotificationAsRead = async (notificationId: string) => {
  try {
    const notificationRef = doc(db, 'notifications', notificationId)
    await updateDoc(notificationRef, { read: true })
    return true
  } catch (error) {
    console.error('Error marking notification as read:', error)
    throw error
  }
}
